export const getUrlWithQueryParams = url => {
  const originalUrl = new URL(url, window.location.origin)
  const newQueryParams = window.location.search.slice(1)
  return newQueryParams ? originalUrl.href + (originalUrl.search ? '&' : '?') + newQueryParams : originalUrl.href
}
